/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  password: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('password'), null], i18n.t('PASSWORD_NOT_MATCH_KEY'))
    .required(i18n.t('REQUIRED_FIELD_KEY')),
});
